// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React from 'react';

interface MultilineTextProps extends React.ComponentPropsWithRef<'div'> {
  text: string;
}

const MultilineText = ({ text }: MultilineTextProps): JSX.Element | null => {
  if (!text) {
    return null;
  }

  return <>{
    text.split('\n').map((text, index) => (
      <React.Fragment key={index}>
        {index !== 0 && <br></br>}
        {text}
      </React.Fragment>
    ))
  }</>
}

export { MultilineText as default };
